if (!customElements.get('mug-color-select')) {
  customElements.define('mug-color-select', class extends HTMLElement {
    connectedCallback() {
      this.onColorChange = (event) => {
        if (event.target.tagName !== 'SELECT') return;
        const option = event.target.selectedOptions[0];
        const size = this.closest('product-info')?.querySelector('variant-selects select')?.value;
        const urls = JSON.parse(option.dataset.sizeUrls || '{}');
        const url = new URL(urls[size] || option.value, window.location.origin);
        if (url.origin === window.location.origin) window.location.assign(url.href);
      };
      this.addEventListener('change', this.onColorChange);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onColorChange);
    }
  });
}
